// extracted by mini-css-extract-plugin
export default {"faq":"Faqs_faq__dnAQs"};